import {SignUpContent} from "../../components/sign-up/SignUpContent";
import {CentralContent} from "../../components/central-content/CentralContent";
import {Page} from "../Page";

export const SignUpPage = () => <Page>
  <CentralContent>
    <SignUpContent/>
  </CentralContent>
</Page>;
